import styled from '@emotion/styled'

export const StyledDivider = styled.div`
  border-bottom: solid 1px var(--White90);
`
